import React from "react";

import TemplateL from "../components/projects/TemplateL";
import TemplateR from "../components/projects/TemplateR";

export default class Portfolio extends React.Component {
    constructor () {
        super();
    }

    render() {
        return (
            <main className="portfolio-container">
                <div className="portfolio-wrapper">
                    <h2>Content to come!</h2>
                </div>
            </main>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Portfolio.js